<template>
  <div class="content-center none-click">
    <div class="banner">
      <img src="@/assets/Mobile/images/about/dynamic-banner.png" alt="">
    </div>
    <div class="news">
      <div class="news-title">新闻中心</div>
      <div v-for="(item, index) in newsList" :key="index" class="news-item" @click="jumpDetail(item.infoNo)">
        <div class="text">
          <span class="title">{{ item.title }}</span>
          <span class="date">{{ item.createTime }}</span>
        </div>
        <img :src="item.coverUrl" alt="">
      </div>
      <a-pagination v-model="pageNum" simple :default-page-size="pageSize" :total="total" class="pagenation" @change="onChange" />
    </div>
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import { getOfficialWebsiteInfomationList } from '@/apis/index'

export default {
  metaInfo: metaInfo.Dynamic,
  data() {
    return {
      newsList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    }
  },
  mounted() {
    this.getDynamicList()
  },
  methods: {
    jumpDetail(id) {
      this.$router.push({ path: '/m/dynamicDetail/' + id })
    },
    getDynamicList() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      getOfficialWebsiteInfomationList(params).then(res => {
        const { rows, total } = res
        this.newsList = rows
        this.total = total
      }).catch(err => {
        this.$message.error(err)
      })
    },
    onChange(page) {
      this.pageNum = page
      this.getDynamicList()
    }
  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 200px;
  margin-top: 50px;
  img {
    width: 100%;
  }
}
.news {
  padding: 0 17px;
  .news-title {
    margin: 20px 0;
    font-size: 20px;
    font-weight: 600;
    color: #222222;
    line-height: 28px;
    text-align: left;
  }
  .pagenation {
    margin: 20px auto;
  }
  .news-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .text {
      width: 220px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: start;
      text-align: left;
      .title {
        font-size: 14px;
        font-weight: 500;
        color: #222222;
        line-height: 20px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .date {
        font-size: 12px;
        font-weight: 400;
        color: #8B8FA1;
        line-height: 17px;
      }
    }
    img {
      width: 108px;
      height: 65px;
    }
  }
}
</style>
